<template>
  <div>
    <div class="card card--white">
      <div class="card card--container">
        <form @submit.prevent="save">
          <h-input 
            label="Choose a Name for your Custom Assessment" 
            hint="This will be displayed to your client and when you share it"
            v-model="assessment.name" required />
          <h-input 
            label="Give your clients a description of what your assessment measures and the benefits of taking the assessment." 
            hint="This will be displayed to your client and when you share it" 
            v-model="assessment.description" required/>
          <h-input 
            label="Give your participants instructions for how to complete the assessment. You may want to tell them how long it should take. That the questions/items are on a scale from 1-7 (strongly disagree to strongly agree)." 
            v-model="assessment.instructions"/>
          
          <div class="attributes small-top">
            <v-checkbox v-for="attribute in attributes" :key="attribute.id" v-model="assessment.attributes" :value="attribute.id">
              <div slot="label">
                <h3>{{attribute.name}} 
                  <button type="button" @click.stop="display=attribute"><i class="material-icons">info</i></button></h3>
                <div>{{attribute.description}}</div>
              </div>
            </v-checkbox>
          </div>
          <modal v-if='display' @submit="display=false" @close='display=false' :title="display.name" btn="close">
              <div v-if="display.description">{{display.description}}</div>
              <div class="section small-top">
                <h4>Questions:</h4>
                <div v-for="question in display.questions" :key="question.id">
                  {{question.question}}
                </div>
              </div>
          </modal>
          <input type="submit" :disabled="saving" class="button button--flat primary--text" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import modal from "@/components/modal/default";

const ATTRIBUTE_STORE = "CoachAttributes";
const ASSESSMENT_STORE = "CoachAssessments";

export default {
  components: { modal },
  data() {
    return {
      attributes: [],
      display: false,
      saving: false,
      assessment: {
        attributes: [],
        public: false
      }
    };
  },
  created() {
    dataStore.findAll(ATTRIBUTE_STORE, { limit: 500 }).then(r => {
      this.attributes = r;
      this.attributes.sort((a, b) => {
        const aValue = a.name.toUpperCase();
        const bValue = b.name.toUpperCase();
        if (aValue > bValue) {
          return 1;
        }
        if (aValue === bValue) {
          return 0;
        }
        return -1
      })
    });
  },
  methods: {
    save() {
      this.saving = true;
      dataStore.create(ASSESSMENT_STORE, this.assessment).then(() => {
        snackbar.update("Saved");
      }).finally(() => {
        this.saving = false;
        this.$router.push("/coach/assessments");
      });
    }
  },
  computed: {
    numOfQuestions() {
      return this.addedAttributes.reduce((total, attribute) => total + attribute.questions.length, 0)
    }
  }
};
</script>

<style lang="less" scoped>
.attributes {
  height: 50vh;
  overflow-y: auto;
  border-style: solid;
  border-width: 1px;
  margin: 5px;
  margin-top: 15px;
  padding: 10px;
}
input[type='search'] {
  line-height: 20px;
  border-style: solid;
  border-width: 1px;
  right: 0px;
}
</style>
